import PropTypes from 'prop-types';
import React from 'react';
import * as dates from 'commons/models/dates';
import { DatePicker } from '@progress/kendo-react-dateinputs';

export default function DateFormatCell(props) {
  const handleChange = e => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: dates.dateBdFormat(e.value)
      });
    }
  };

  return (
    <td>
      {props.dataItem.inEdit === true && props.updatable ? (
        <DatePicker format='dd/MM/yyyy' onChange={handleChange} value={dates.dateBdToDate(props.dataItem[props.field], '00:00')} />)
        :
        (<span>
          {props.field === 'dt_req_aff' || props.field === 'dt_req_c'
            ? props.dataItem[props.field]
            : dates.dateQueryFormatReverse(props.dataItem[props.field])}
        </span>)}
    </td>
  );
}

DateFormatCell.propTypes = {
  dataItem: PropTypes.any,
  field: PropTypes.any,
  updatable: PropTypes.any,
  onChange: PropTypes.any
};
